"use client";

import { ArrowRight, Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Review() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="15233" id="website-review-cta" className="bg-background text-foreground py-32 md:py-44">
      <div className="mx-auto w-full max-w-[1440px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-12 gap-4 md:gap-8">
          {}
          <div className="col-span-12">
            <div className="h-px w-full bg-foreground" />
          </div>

          {}
          <div className="col-span-12 md:col-start-2 md:col-span-10 pt-24 md:pt-24">
            {}
            <div className="font-mono text-xs uppercase text-muted-foreground mb-12" style={{
            letterSpacing: "0.14em"
          }}>
              Request a Website Audit
            </div>

            {}
            <h2 ref={headlineRef} className="font-default text-foreground" style={{
            fontWeight: 600,
            fontSize: "clamp(2.25rem, 4.4vw, 4rem)",
            letterSpacing: "-0.02em",
            lineHeight: 1.02,
            clipPath: headlineVisible ? "inset(0 0 0 0)" : "inset(100% 0 0 0)",
            transition: "clip-path 700ms cubic-bezier(0.2, 0.7, 0.2, 1)"
          }}>
              Is your digital presence underperforming? Let us provide the{" "}
              <span style={{
              color: "var(--primary)"
            }}>solution</span>.
            </h2>

            {}
            <div ref={bodyRef} className="mt-12 md:max-w-[58.33%]" style={{
            opacity: bodyVisible ? 1 : 0,
            transform: bodyVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 520ms cubic-bezier(0.2, 0.7, 0.2, 1) 120ms, transform 520ms cubic-bezier(0.2, 0.7, 0.2, 1) 120ms"
          }}>
              <p className="font-default text-muted-foreground" style={{
              fontWeight: 300,
              fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
              letterSpacing: "-0.003em",
              lineHeight: 1.55
            }}>
                Our team analyzes your website's performance, user experience, and conversion potential to deliver actionable insights that drive measurable growth.
              </p>
            </div>

            {}
            <div className="mt-14 flex flex-col md:flex-row md:items-center gap-4 md:gap-10" style={{
            opacity: bodyVisible ? 1 : 0,
            transform: bodyVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 520ms cubic-bezier(0.2, 0.7, 0.2, 1) 220ms, transform 520ms cubic-bezier(0.2, 0.7, 0.2, 1) 220ms"
          }}>
              <Button asChild className="group h-14 px-8 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md font-default" style={{
              fontWeight: 600,
              letterSpacing: "0.02em"
            }}>
                <Link to="/ContactPage">
                  Request your audit
                  <ArrowRight className="ml-2 size-4 transition-transform duration-200 group-hover:translate-x-1" />
                </Link>
              </Button>

              <Link to="#" className="group inline-flex items-center gap-3 font-default text-foreground" style={{
              fontWeight: 500,
              letterSpacing: "0.01em"
            }}>
                <Download className="size-4" />
                <span className="border-b border-foreground pb-1 transition-all duration-200 group-hover:border-b-2">
                  Download audit sample
                </span>
                <span className="font-mono text-xs text-muted-foreground" style={{
                letterSpacing: "0.02em"
              }}>
                  {"(PDF, 1.8MB)"}
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}